import moment from 'moment';

import {ExperimentResultsCache} from 'apps/experiments/src/types';
import {LocalizationStore} from 'common/i18n/store';

export const formatDecisionMessage = (i18n: LocalizationStore, resultsCache?: ExperimentResultsCache) => {
  if (!resultsCache) {
    return ``;
  }
  let shippedMessage = ``;
  if (resultsCache.variant) {
    shippedMessage = `${i18n.t(`experiments.banner.message.shipped`, {variant: resultsCache.variant})}\n`;
  }
  return `${shippedMessage}${resultsCache.message}\n- ${i18n
    .t(`experiments.banner.message.updated`, {
      updatedAt: moment(resultsCache.messageUpdatedAt).format(`L`),
      updatedBy: resultsCache.messageUpdatedBy,
    })
    .replaceAll(`&#x2F;`, `/`)}`;
};
